import {useNavigation} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {
  Image,
  ImageBackground,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {Images} from '../../../constants/Images';
import {styles} from './styles';
import Toast from '../../../components/Toast/Toast';
import {NavigationProps} from '../../../navigation/Routes';
import {AppRoutes} from '../../../navigation/Routes.types';

const ValidatedToken = () => {
  const [toast, setToast] = useState<boolean>(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setToast(false);
      clearInterval(interval);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const {navigate} = useNavigation<NavigationProps>();
  return (
    <ImageBackground
      // source={Images.backgroundCoke}
      style={styles.imageBackground}>
      {toast && <Toast title="Conta validada com sucesso!" />}
      <View style={styles.horizontalSpace}>
        <View style={styles.container}>
          <Image source={Images.ProfileSimbol} style={styles.simbol} />
          <Text style={styles.title}>Conta validada com sucesso!</Text>
          <Text style={styles.description}>
            Agora é possível acessar o sistema pelo botão abaixo
          </Text>
          <TouchableOpacity onPress={() => navigate(AppRoutes.LOGIN)}>
            <Text style={styles.goBack}>Voltar a tela de login</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

export default ValidatedToken;
